import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RedirectGuard } from './app.redirectguard';
import { HeaderComponent } from './header/header/header.component';
import { HomeComponent } from './Patient/home/home.component';
import { FooterComponent } from './footer/footer/footer.component';
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignupComponent } from './Patient/signup/signup.component';
import { HcphomeComponent } from './hcp/hcphome/hcphome.component';
import { HcpsignupComponent } from './hcp/hcpsignup/hcpsignup.component';
import { HcptooltipComponent } from './hcptooltip/hcptooltip.component';
import { HcpfooterComponent} from './hcpfooter/hcpfooter.component';
import { HcpheaderComponent } from './hcpheader/hcpheader.component';
import { HppopupComponent } from './hppopup/hppopup.component';
import { CookiespolicyComponent } from './cookiespolicy/cookiespolicy.component';








@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        HomeComponent,
        FooterComponent,
        SignupComponent,
        HcphomeComponent,
        HcpsignupComponent,
        HcptooltipComponent,
        HcpfooterComponent,
        HcpheaderComponent,
        HppopupComponent,
        CookiespolicyComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule], providers: [RedirectGuard, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
